module.exports = __webpack_public_path__ + "media/hero_4.3c16a59b.mp4";